import React, { useState, createContext, useContext, useEffect } from 'react';

interface IIconsContext {
    iconsUrl: string | null;
    isLoading: boolean;
}

interface IProps {
    children: React.ReactNode
}

const ICON_SOURCES = [
    'https://assets-hml.toroinvestimentos.com.br/front/icons/icons.svg',
    'https://assets-hml.toroinvestimentos.com.br/front/icons/common_icons.svg',
];

const IconsContext = createContext<IIconsContext | null>(null);

export const IconsProvider = ({ children }: IProps): JSX.Element => {

    const [iconsUrl, setIconsUrl] = useState<string | null>(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        (async () => {
            if (!iconsUrl && isLoading) {
                setIsLoading(true);
                const iconsHtml = await Promise.all(ICON_SOURCES.map(source => fetch(source).then(r => r.text())));
                const icons = iconsHtml.flatMap(html => Array.from(new DOMParser().parseFromString(html, 'text/xml').children[0].children));
                const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
                svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
                svg.setAttribute('style', 'display: none');
                icons.forEach(i => svg.appendChild(i));
                const blob = new Blob([svg.outerHTML], { type: 'image/svg+xml' });
                setIconsUrl(URL.createObjectURL(blob));
            }
            setIsLoading(false);
        })();
    }, [iconsUrl, isLoading]);

    return (
        <IconsContext.Provider value={{ iconsUrl, isLoading }}>
            {children}
        </IconsContext.Provider>
    );

};

export const useIcons = () => {
    const context = useContext(IconsContext);
    if (!context) throw new Error('useIcons must be used within an IconsProvider');
    return context;
};
